import React, { useState, useEffect } from "react";
import { Flex, Heading, Text, Button, Box } from "@chakra-ui/react";
import {
  // textPrimary,
  textSecondary,
  white,
  // color4,
  primaryAlt,
} from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../hooks/useThemeColors";
// import { DropdownButton } from "react-bootstrap";
// import DropdownButtonAlt from "../../../../components/buttons/DropdownButtonAlt";
// import DropdownButtonNew from "../../../../components/buttons/DropdownButtonNew";
import DropdownButtonTitle from "../../../../components/buttons/DropdownButtonTitle";
import { motion } from "framer-motion";
// import pl from "dayjs/locale/pl";
import { useDispatch, useSelector } from "react-redux";
import { getTenantSubscriptionUsageAction } from "../../../../actions/tenantActions";
// import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

const MotionFlex = motion(Flex);

const DashboardLimits = ({ hasSubscriptionAccess }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slug } = useParams();

  // Filter subscriptions to include only active ones
  // const activeSubscriptions = tenant.subscriptions.filter(
  //   (sub) => sub.isActive
  // );

  const [isSelectionOn, setIsSelectionOn] = useState(false);

  // COLORS
  const {
    whiteMode,
    planBorderSpecialMode,
    backgroundLightMode,
    textPrimaryMode,
  } = useThemeColors();

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const {
    loading: loadingUsage,
    error: errorUsage,
    success: successUsage,
    limits,
  } = useSelector((state) => state.tenantGetSubscriptionUsage);

  // USE EFFECT
  useEffect(() => {
    if (userInfo) {
      dispatch(getTenantSubscriptionUsageAction("treatmentPlans", slug));
    }
  }, [dispatch, slug]);

  // Pick the correct module's limits
  const moduleLimits = limits["treatmentPlans"] || {
    usageCount: 0,
    limitCount: 0,
  };

  const percentageFilled =
    moduleLimits.limitCount > 0
      ? (moduleLimits.usageCount / moduleLimits.limitCount) * 100
      : 0;

  // LOG
  // console.log("userInfo:", userInfo);
  // console.log("limits:", limits);
  // console.log("slug:", slug);

  return (
    <Flex
      w="100%"
      bg={whiteMode}
      borderRadius="1rem"
      p="1rem 1.5rem"
      h="146px"
      minH="146px"
      maxH="146px"
      direction="column"
    >
      {!isSelectionOn ? (
        <Flex w="100%" align="center" justify="space-between" minH="2rem">
          <Flex align="center">
            <Heading
              fontSize="1.125rem"
              fontWeight="600"
              color={textPrimaryMode}
            >
              {t("dashboard.subscription")}
            </Heading>
            {/* <Text
              fontSize="0.8rem"
              color={textSecondary}
              fontWeight="400"
              px="0.5rem"
            >
              |
            </Text> */}
            {/* <Text fontSize="0.8rem" color={textSecondary} fontWeight="500">
              {planType && planType === "free"
                ? t("common.free")
                : t("common.premium")}
            </Text> */}
          </Flex>

          <Flex align="center" justify="flex-end" gap="0.5rem">
            {hasSubscriptionAccess && (
              <Button
                size="sm"
                fontSize="0.8rem"
                bg={backgroundLightMode}
                color={textSecondary}
                borderRadius="1rem"
                _hover={{ bg: primaryAlt, color: white }}
                onClick={() =>
                  navigate(`/${slug}/settings/clinic-settings/active-modules`)
                }
              >
                {limits &&
                limits.treatmentPlans &&
                limits.treatmentPlans.plan &&
                limits.treatmentPlans.plan === "free"
                  ? t("dashboard.upgradeFree")
                  : t("dashboard.upgrade")}
              </Button>
            )}
          </Flex>
        </Flex>
      ) : (
        <Flex w="100%" align="center" justify="flex-start" minH="2rem">
          <DropdownButtonTitle
            iconComponent={null} // Optional icon if needed
          />
        </Flex>
      )}

      <Flex w="100%" m="0.5rem 0 0">
        <Text fontSize="xs" color={textSecondary} fontWeight="500">
          {t("dashboard.yourPlan")}:
          <Text
            as="span"
            ml={1}
            fontSize="xs"
            color={textPrimaryMode}
            fontWeight="500"
          >
            {limits &&
            limits.treatmentPlans &&
            limits.treatmentPlans.plan &&
            limits.treatmentPlans.plan === "free"
              ? t("dashboard.freePlanText")
              : limits &&
                limits.treatmentPlans &&
                limits.treatmentPlans.plan &&
                limits.treatmentPlans.plan === "premium"
              ? t("dashboard.premiumPlanText")
              : t("dashboard.enterprisePlanText")}
          </Text>
        </Text>
      </Flex>

      {/* Limits Display based on Selected Subscription */}
      <Flex
        w="100%"
        align="center"
        justify="space-between"
        p="0rem 0"
        m="0.5rem 0 0"
        gap="2rem"
      >
        {/* TREATMENT PLANS LIMIT */}
        <Flex w="100%" direction="column">
          <Flex w="100%" align="center" justify="space-between">
            <MotionFlex
              width={percentageFilled + "%"}
              // width={moduleLimits.usageCount + "%"}
              bg={primaryAlt}
              h="1.25rem"
              borderRadius="0.5rem"
              border={`1px solid ${whiteMode}`}
              position="relative"
              initial={{ width: "0%" }}
              animate={{ width: `${percentageFilled}%` }}
              // animate={{ width: `${moduleLimits.usageCount}%` }}
              transition={{ duration: 0.6 }}
            ></MotionFlex>
            {/* <Flex px="1px">
              <Box w="2px" h="1rem" bg="#9AA0AC" borderRadius="1rem" />
            </Flex> */}
            <MotionFlex
              w={100 - percentageFilled + "%"}
              // w={100 - moduleLimits.usageCount + "%"}
              bg={backgroundLightMode}
              h="1.25rem"
              borderRadius="0.5rem"
              border={`1px solid ${whiteMode}`}
              bgImage={`linear-gradient(-45deg, ${whiteMode} 25%, ${planBorderSpecialMode} 25%, ${planBorderSpecialMode} 50%, ${whiteMode} 50%, ${whiteMode} 75%, ${planBorderSpecialMode} 75%, ${planBorderSpecialMode} 100%)`}
              bgSize="10px 10px"
              initial={{ width: "0%" }}
              animate={{ width: `${100 - percentageFilled}%` }}
              // animate={{ width: `${percentageFilled}%` }}
              transition={{ duration: 0.6 }}
            />
          </Flex>
          <Flex w="100%" align="center" justify="space-between" p="0.5rem 0 0">
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              {limits &&
              limits.treatmentPlans &&
              limits.treatmentPlans.plan &&
              limits.treatmentPlans.plan === "free"
                ? t("dashboard.tpLimitFree")
                : limits &&
                  limits.treatmentPlans &&
                  limits.treatmentPlans.plan &&
                  limits.treatmentPlans.plan === "premium"
                ? t("dashboard.tpLimitPremium")
                : t("dashboard.tpLimitEnterprise")}
            </Text>
            {limits &&
            limits.treatmentPlans &&
            limits.treatmentPlans.plan !== "enterprise" ? (
              <Text fontSize="xs" color={textPrimaryMode} fontWeight="500">
                {/* {currentNumber} */}
                {moduleLimits.usageCount}
                <Text as="span" color={textSecondary}>
                  /{moduleLimits.limitCount}
                </Text>
              </Text>
            ) : (
              <Text fontSize="xs" color={textPrimaryMode} fontWeight="500">
                <>&#8734;</>
              </Text>
            )}
          </Flex>
        </Flex>
        {/* EMAIL LIMIT */}
      </Flex>
    </Flex>
  );
};

export default DashboardLimits;
